import { render, staticRenderFns } from "./IllustrationSummarySection.vue?vue&type=template&id=3698a76e"
import script from "./IllustrationSummarySection.vue?vue&type=script&lang=ts"
export * from "./IllustrationSummarySection.vue?vue&type=script&lang=ts"
import style0 from "./IllustrationSummarySection.vue?vue&type=style&index=0&id=3698a76e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports